import { getMissingPolicyStartDate } from 'scenes/home/selectors';
import {
  HomeFlowDefinition,
  HomeFunnelState,
  HomeFlowType,
  HomeStepType,
} from 'scenes/home/types';

export const forwardLinks: HomeFlowDefinition = {
  [HomeStepType.ReviewPolicyStartDate]: (state: HomeFunnelState) => ({
    step: HomeStepType.QuotePrice,
    flow: HomeFlowType.CoverOptions,
    quoteDetails: {
      ...state.quoteDetails,
      policyStartDate: getMissingPolicyStartDate(state),
    },
  }),
};

export const backwardLinks: HomeFlowDefinition = {};
